module.exports = __webpack_public_path__ + "img/setup-dark.8a81961b.svg";